 <wiz-vgroup horizontalAlign="center" verticalAlign="center" width="100%" height="100%"> 
 <wiz-vgroup>
    <wiz-hgroup verticalAlign="center" (click)="do('thumb')">
          <wiz-icon style="font-size: 40px;" class="basicIcon black hover" >view-thumbnail</wiz-icon>
          <wiz-label wizLabel="$.widget.show.thumb.$" style="cursor: pointer;"></wiz-label>
      </wiz-hgroup>
      <wiz-hgroup verticalAlign="center" (click)="do('list')">
          <wiz-icon style="font-size: 40px;" class="basicIcon black hover" >view-list</wiz-icon>
          <wiz-label wizLabel="$.widget.show.liste.$" style="cursor: pointer;"></wiz-label>
      </wiz-hgroup>
      <wiz-hgroup verticalAlign="center" (click)="do('add')">
          <wiz-icon style="font-size: 40px;" class="basicIcon black hover" >item</wiz-icon>
          <wiz-label wizLabel="$.widget.show.add.$" style="cursor: pointer;"></wiz-label>
      </wiz-hgroup>

      <wiz-hgroup verticalAlign="center" (click)="do('gatling')">
          <wiz-icon style="font-size: 40px" class="basicIcon black hover"><mat-icon style="font-size: 40px; width: 40px; height: 40px;">bolt</mat-icon></wiz-icon>
          <wiz-label wizLabel="$.widget.show.mass.$" style="cursor: pointer;"></wiz-label>
      </wiz-hgroup>

 </wiz-vgroup>



 </wiz-vgroup>
 
